module.exports = __webpack_public_path__ + "img/6.fa6f76dd.jpg";